export default {
  title: 'System Personalization',

  labels: {
    theme: 'Select the desired theme'
  }
}
